import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../shared/confirm-dialog/confirm-dialog.component';
import { RestService } from 'src/app/services/rest-service';

@Injectable({
  providedIn: 'root'
})
export class SdtService {

  constructor(private dialog:MatDialog,public restService: RestService) {}

  openConfirmDialog(msg){
    return this.dialog.open(ConfirmDialogComponent,{
      width: '390px',
      panelClass:'confirm-dialog-container',
      disableClose:true,
      data:{
        message:msg
      }
    })
  }

  selectedDevices = [];
  selectedDevicesPM = [];
  deviceName;
  sdtReason: any;
  sdtStartDate: any;
  sdtEndDate: any;
  createdBy: any;
  createdAt: any;
  updatedBy: any;
  updatedAt:any;
  pmStartDate:any;
  pmEndDate:any;
  pmReason:any;
  pmcreatedBy:any;
  pmcreatedAt:any;
  pmupdatedBy:any;
  pmupdatedAt:any;
  deviceIndex: any;
  DBdata: any;
  pmDBdata:any;
  monitorData = [];
  selectedDevice={};
  selectedDevicePM:any;
  siteTimezone: any;

  formData = {
    sdtStartDate: '',
    sdtEndDate: '',
    sdtReason: '',
    createdBy: '',
    createdAt: '',
    updatedAt: '',
    updatedBy:''
  }

  formDataPM = {
    pmStartDate : '',
    pmEndDate : '',
    pmReason : '',
    pmcreatedBy : '',
    pmupdatedBy : ''
  }

  getMonitorDataByDeviceName(deviceName) {
    return this.DBdata.filter(ele => ele.deviceName == deviceName)
  }

  private deviceDetails: any;
  setDeviceDetails(details: any) {
    this.deviceDetails = details;
  }
  getDeviceDetails() {
    return this.deviceDetails;
  }
  
}
